// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1ihSu","head":"ProcedureTableInfo_head__3CnMy"};